/** @jsx jsx */
// @flow

import bemify, { toModifiers } from 'bemify-js';

import { jsx } from '@emotion/core';
import { labelStyles } from '@zapier/common-utils';
import { Colors, Icon, Typography } from '@zapier/design-system';

import SimplePopover, {
  SimplePopoverWrapper,
} from 'app/common/components/SimplePopover';
import 'app/login/components/FeatureItems.scss';

import { type Node } from 'react';

import type { KindType } from 'app/common/types';

const bem = bemify('feature-items');

type FeatureItemProps = {
  children: Node,
};

const Styles = labelStyles(__filename, {
  descriptionContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    marginTop: 15,

    '&:first-of-type': {
      marginTop: 0,
    },
  },
  description: {
    ...Typography.paragraph3,
    color: Colors.gray,
    margin: '-2px 0 0 10px',
  },
});

const FeatureItem = (props: FeatureItemProps) => (
  <div css={Styles.descriptionContainer}>
    <Icon color="success400" name="formCheckCircle" size={20} />
    <div css={Styles.description}>{props.children}</div>
  </div>
);

export const TeamContainerFeatureItems = (
  kind?: KindType,
  className?: string
) => (
  <div className={bem(toModifiers(kind), className)}>
    <FeatureItem>Help build and maintain this integration</FeatureItem>
    <FeatureItem>Access data on how your integration is performing</FeatureItem>
    <FeatureItem>Get a free Zapier trial</FeatureItem>
  </div>
);

export const PlatformContainerWhyFeaturedItems = (
  kind?: KindType,
  className?: string
) => (
  <div className={bem(toModifiers(kind), className)}>
    <FeatureItem>Free to build, with no recurring charges.</FeatureItem>
    <FeatureItem>
      Build one integration and unlock thousands of apps for your customers'
      workflows.
    </FeatureItem>
    <FeatureItem>
      Gain access to resources (documentation, Zapier Community, developer
      support, performance data, and co-marketing perks) to help you boost
      customer adoption.
    </FeatureItem>
  </div>
);

type FeatureItemsProps = {
  kind?: KindType,
  className?: string,
};

const FeatureItems = (props: FeatureItemsProps) => (
  <div className={bem(toModifiers(props.kind), props.className)}>
    <FeatureItem>Easy setup, no coding required</FeatureItem>
    <FeatureItem>Free forever for core features</FeatureItem>
    <FeatureItem>
      14-day trial of&nbsp;
      <SimplePopoverWrapper className={bem('__popover')} isHoverable={true}>
        <span className={bem('__popover-hover')}>premium features</span>
        <SimplePopover direction="up" kind="compact no-wrap dark">
          <ul className={bem('__popover-content')}>
            <li>Zaps with 3+ steps</li>
            <li>Priority support</li>
          </ul>
        </SimplePopover>
      </SimplePopoverWrapper>
      &nbsp;&amp; apps
    </FeatureItem>
  </div>
);

export default FeatureItems;
